import i18n from '@Root/setupLocales';

export const getTranslation = (name: string, params?: object) => {
  const result = i18n.t(name, params);

  if (result !== name) {
    return result;
  }
};
